import React from 'react';
import { Hero } from './components/Hero';
import { Story } from './components/Story';
import { Areas } from './components/Areas';
import { Mentoring } from './components/Mentoring';
import { Benefits } from './components/Benefits';
import { Testimonials } from './components/Testimonials';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppFloat } from './components/WhatsAppFloat';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-ink text-ivory font-sans selection:bg-gold selection:text-ink" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Story data-id="element-4" />
        <Areas data-id="element-5" />
        <Mentoring data-id="element-6" />
        <Benefits data-id="element-7" />
        <Testimonials data-id="element-8" />
        <FinalCTA data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
      <WhatsAppFloat data-id="element-11" />
    </div>;
}